import { Link } from 'lucide-react';
import React from 'react';

function ContactPage() {
  return (
    <div className="page-shell">
      <section className="hero-banner hero-banner--compact" style={{ backgroundImage: 'url(https://images.unsplash.com/photo-1469474968028-56623f02e42e?auto=format&fit=crop&w=1600&q=80)' }}>
        <div className="hero-overlay" />
        <div className="hero-content container">
        
          <h1>Contact.</h1>
          <p>Whether you are joining an event, asking for prayer, or visiting for the first time, our team is ready to help.</p>
        </div>
      </section>
      


      <section className="find-wrc ">

    <div className="container">

     

        <div className="find-information">

            <div className="find-row">

                <span>LOCATION</span>

                <h3>

                    WRC Deliverance Church
                    <br />
                    Kona Ya Musa
                    <br />
                    Kwale, Kenya
                          <br />
                  Tell :
                        <br />
                        +254113717090

                </h3>

            </div>

            <div className="find-row">

                <span>SUNDAY WORSHIP</span>

                <h3>

                    1st Service — 7:00 AM to 9:30 AM
                    <br />
                    2nd Service — 10:00 AM to 1:00 PM

                </h3>

            </div>

            <div className="find-row">

                <span>PRAYER & FASTING</span>

                <h3>

                    Monday
                    <br />
                    5:00 PM to 6:30 PM

                </h3>

            </div>

            <div className="find-row">

                <span>BIBLE STUDY</span>

                <h3>

                    Wednesday
                    <br />
                    5:00 PM to 6:30 PM

                </h3>

            </div>


              <div className="find-row">

                <span>HOME BIBE STUDY</span>

                <h3>

                    Every Friday
                    <br />

                </h3>

            </div>

        </div>

        <div className="find-button">

            <a

                href="https://maps.google.com"

                target="_blank"

                rel="noreferrer"

                className="button button--primary"

            >

                Get Directions

            </a>

        </div>

    </div>

</section>

    

      <section className="section container">
        <div className="contact-panel">
          <div>
            <p className="eyebrow">Visit or connect</p>
            <h2>Let us know how we can support you.</h2>
            <p className="section-copy">We welcome visits, pastoral conversations, and thoughtful messages from our community.</p>
          </div>
          <div className="contact-card">
            <p><strong>Email</strong><br />oscarkwanga@....com</p>
            <p><strong>Address</strong><br />UkundaKonaYaMusa, Kwale</p>
            <a className="button button--primary" href="oscarkwanga@gmail.com">Send a message</a>
          </div>
        </div>
      </section>
    </div>
  );
}

export default ContactPage;
